module.exports = __webpack_public_path__ + "images/d3d2fceb70d005ae45db479d47078f2d.svg";